import type { VideoModelBrand } from "@saas/shared/components/ModelBrandIcon";
import type { ModelBrand } from "@saas/shared/config/ai-models";
import type { I2VModelId } from "../types";

/**
 * 视频模型前面的品牌 logo（10/20）。Seedance 用字节的（图标键是 seedream），Veo / Gemini 用 Google 的。
 * Basic 没有对外的公开名，和图片工作台的 V3.0 一样挂站内 logo。
 */
const I2V_MODEL_BRANDS: Record<I2VModelId, ModelBrand | VideoModelBrand> = {
	basic: "imagesart",
	"basic-between": "seedream",
	"fast-2.0": "nano-banana",
	"veo-3.1-fast": "nano-banana",
	"veo-3.1-quality": "nano-banana",
	"fast-3.0": "grok",
	"quality-2.0": "minimax",
	"quality-2.0-ref": "minimax",
	"quality-2.0-text": "minimax",
	"wan-3.0": "wan",
	"wan-3.0-prime": "wan",
	"quality-3.0": "nano-banana",
	"master-2.0": "kling",
	"master-2.0-ref": "kling",
	"master-2.0-text": "kling",
	"kling-4.0": "kling",
	"kling-4.0-ref": "kling",
	"kling-2.6-motion": "kling",
	// OmniHuman 也是字节的
	"omnihuman-2": "seedream",
	"master-3.0": "seedream",
	"seedance-2-mini": "seedream",
	"seedance-2-fast": "seedream",
	"seedance-2": "seedream",
	"seedance-2.5": "seedream",
};

export function getI2VModelBrand(id: I2VModelId) {
	return I2V_MODEL_BRANDS[id];
}
